import { FC } from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ListBoxMultiple } from "@/components/Interface/FormFields/ListBoxMultiple/ListBoxMultiple";
import {
  additionalColumns,
  AdditionalColumnsEnum,
  FilterDialogForm,
} from "@/components/Portal/components/PortalDeviceListFilter/types";

interface Props {
  control: Control<FilterDialogForm, any>;
}

export const ColumnFilter: FC<Props> = ({ control }) => {
  const { t } = useTranslation("portal");

  return (
    <div>
      <Controller<FilterDialogForm>
        control={control}
        name="additionalColumns"
        render={({ field: { onChange, value } }) => (
          <ListBoxMultiple<AdditionalColumnsEnum>
            className="full-width"
            inverted
            showSelectedAsTags
            selected={
              (Array.isArray(value)
                ? value
                : value
                  ? [value]
                  : []) as AdditionalColumnsEnum[]
            }
            setSelected={onChange}
            displayValue={(value) => t(`common.device.attributes.${value}`)}
            availableValues={[...additionalColumns]}
            placeholder={t("cockpit.filter.dropdowns.chooseColumns")}
            itemLabel={t("cockpit.filter.dropdowns.column")}
          />
        )}
      />
    </div>
  );
};
